import { useTranslation } from 'react-i18next';
import TitleBar from '../utils/TitleBar.js';

function InverterStatus(props) {
    const { t } = useTranslation();
    const { data } = props;

    return (
        <div style={{
            padding: '10px 15px'
        }}>
            <TitleBar title={t('Inverter Status')} data={data} />
            <div style={{backgroundColor: '#f0f0f0', width: '100%', borderRadius: '10px', float: 'left', padding: '4px 6px', marginTop: '20px'}}>
                <div style={{fontSize: '12px', fontWeight: 'bold', borderBottom: '1px solid #1B8AC5', marginBottom: '6px'}}>
                    {t('Current,Voltage&Temperature')}
                </div>
                <div>
                    <div style={{fontSize: '10px'}}>{t('Max Charge Current')}: {data ? (((data["MaxChargeCurrent"] - 32767) * 0.1).toFixed(1)) + "A" : "-"}</div>
                    <div style={{fontSize: '10px'}}>{t('Max Discharge Current')}: {data ? (((data["MaxDischargeCurrent"] - 32767) * 0.1).toFixed(1)) + "A" : "-"}</div>
                    <div style={{fontSize: '10px'}}>{t('Charge Voltage')}: {data ? ((data["ChargeVoltage"] * 0.1).toFixed(1)) + "V" : "-"}</div>
                    <div style={{fontSize: '10px'}}>{t('Discharge Voltage')}: {data ? ((data["DischargeVoltage"] * 0.1).toFixed(1)) + "V" : "-"}</div>
                    <div style={{fontSize: '10px'}}>{t('Battery Voltage')}: {data ? ((data["BatteryVoltage"] * 0.1).toFixed(1)) + "V" : "-"}</div>
                    <div style={{fontSize: '10px'}}>{t('Battery Current')}: {data ? (((data["BatteryCurrent"] - 32767) * 0.1).toFixed(1)) + "A": "-"}</div>
                    <div style={{fontSize: '10px'}}>{t('Battery Temperature')}: {data ? (((data["BatteryTemperature"] - 50))) + "℃" : "-"}</div>
                </div>
            </div>
            <div style={{backgroundColor: '#f0f0f0', width: '100%', borderRadius: '10px', float: 'right', padding: '4px 6px', marginTop: '20px'}}>
                <div style={{fontSize: '12px', fontWeight: 'bold', borderBottom: '1px solid #1B8AC5', marginBottom: '6px'}}>
                    {t('Status')}
                </div>
                <div>
                    <div style={{fontSize: '10px'}}>{t('Charge Enable')}: {data ? (data["ChargeEnabled"] == 1 ? t('enabled') : t('disabled')) : "-"}</div>
                    <div style={{fontSize: '10px'}}>{t('Discharge Enable')}: {data ? (data["DischargeEnabled"] == 1 ? t('enabled') : t('disabled')) : "-"}</div>
                    <div style={{fontSize: '10px'}}>{t('Emergency Charge Enable')}: {data ? (data["EmergencyChargeEnabled"] == 1 ? t('enabled') : t('disabled')) : "-"}</div>
                    <div style={{fontSize: '10px'}}>{t('Status')}: {data ? (
                        data["Status"] == 1 ? t('inverter_status.init') : 
                        data["Status"] == 2 ? t('inverter_status.comm') : 
                        data["Status"] == 3 ? t('inverter_status.comm_failed') : 
                        t('inverter_status.unknown')
                    ) : "-"}</div>
                </div>
            </div>
        </div>
    );
}

export default InverterStatus;